
interface LogEntry {
  timestamp: string;
  level: 'debug' | 'info' | 'warn' | 'error';
  message: string;
  context?: Record<string, any>;
  userId?: string;
  route?: string;
}

class Logger {
  private static instance: Logger;
  private buffer: LogEntry[] = [];
  private readonly BUFFER_SIZE = 100;

  private constructor() {}

  static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  private formatLog(entry: LogEntry): string {
    return `[${entry.timestamp}] ${entry.level.toUpperCase()}: ${entry.message}${
      entry.context ? ` | ${JSON.stringify(entry.context)}` : ''
    }`;
  }

  private addToBuffer(entry: LogEntry) {
    this.buffer.push(entry);
    if (this.buffer.length > this.BUFFER_SIZE) {
      this.buffer.shift();
    }
  }

  log(
    level: LogEntry['level'],
    message: string,
    context?: Record<string, any>,
    userId?: string,
    route?: string
  ) {
    const entry: LogEntry = {
      timestamp: new Date().toISOString(),
      level,
      message,
      context,
      userId,
      route
    };

    this.addToBuffer(entry);
    console[level](this.formatLog(entry));

    // In production, you would send this to a logging service
    if (level === 'error') {
      // TODO: Send to error tracking service
    }
  }

  debug(message: string, context?: Record<string, any>, userId?: string, route?: string) {
    this.log('debug', message, context, userId, route);
  }

  info(message: string, context?: Record<string, any>, userId?: string, route?: string) {
    this.log('info', message, context, userId, route);
  }

  warn(message: string, context?: Record<string, any>, userId?: string, route?: string) {
    this.log('warn', message, context, userId, route);
  }

  error(message: string, context?: Record<string, any>, userId?: string, route?: string) {
    this.log('error', message, context, userId, route);
  }

  getRecentLogs(): LogEntry[] {
    return [...this.buffer];
  }
}

export const logger = Logger.getInstance();
